const format = ({data, colors, labels}) => {
  return {
    datasets: [{
      data,
      backgroundColor: colors
    }],
    labels
  }
}

export default {
  snapshotGraphs (state) {
    // check if data is loaded from API
    // if modules property exists, we assume the rest do as well
    if (!state.snapshot.data.modules) return {}

    const contentColors = [
      '#4daf4a',
      '#e41a1c',
      '#c7c7c7'
    ]

    const contentLabels = [
      'active',
      'inactive',
      'archived'
    ]

    const modules = {
      data: [
        state.snapshot.data.modules.active,
        state.snapshot.data.modules.inactive,
        state.snapshot.data.modules.archived
      ],
      colors: contentColors,
      labels: contentLabels
    }

    const components = {
      data: [
        state.snapshot.data.components.active,
        state.snapshot.data.components.inactive,
        state.snapshot.data.components.archived
      ],
      colors: contentColors,
      labels: contentLabels
    }

    const topics = {
      data: [
        state.snapshot.data.topics.active,
        state.snapshot.data.topics.inactive,
        state.snapshot.data.topics.archived
      ],
      colors: contentColors,
      labels: contentLabels
    }

    const members = {
      data: [
        state.snapshot.data.tenant_users.master,
        state.snapshot.data.tenant_users.admin,
        state.snapshot.data.tenant_users.user,
        state.snapshot.data.tenant_users.archived
      ],
      colors: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#c7c7c7'
      ],
      labels: [
        'master',
        'admin',
        'user',
        'archived'
      ]
    }

    const media = {
      data: [
        state.snapshot.data.media.image,
        state.snapshot.data.media.video,
        state.snapshot.data.media.pdf,
        state.snapshot.data.media.audio
      ],
      colors: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3'
      ],
      labels: [
        'image',
        'video',
        'pdf',
        'audio'
      ]
    }

    return {
      modules: format(modules),
      components: format(components),
      topics: format(topics),
      members: format(members),
      media: format(media)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/getters.js